import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  usePageContext,
  ReportButton,
  useEditContext,
  useErrorContext,
} from '@xing-com/crate-entity-pages-common';

import * as Styled from './list.styles';

const RenderEditorOptions: FC = () => {
  const { pageContext } = usePageContext();
  const { headerModule, globalId } = pageContext;

  const ctaType = headerModule?.properties.cta;

  return (
    <>
      <Styled.ListItem
        onClick={() =>
          window.open(
            `/xam/aac/?entity_urn=${globalId}&asset_urn=${globalId}`,
            '_blank'
          )
        }
      >
        <span data-testid="EP_PROMOTE_PAGE">
          <Styled.Link size="small">
            <FormattedMessage
              id="EP_PROMOTE_PAGE"
              defaultMessage="EP_PROMOTE_PAGE"
            />
          </Styled.Link>
        </span>
      </Styled.ListItem>
      {ctaType === 'follow' && (
        <Styled.ListItem
          onClick={() => window.open(`/brandmanager/`, '_blank')}
        >
          <span data-testid="ADMINISTRATE_PAGE">
            <Styled.Link size="small">
              <FormattedMessage
                id="EP_ADMINISTRATE_PAGE"
                defaultMessage="EP_ADMINISTRATE_PAGE"
              />
            </Styled.Link>
          </span>
        </Styled.ListItem>
      )}
      {ctaType === 'follow' && (
        <Styled.ListItem
          onClick={() =>
            window.open('https://community.xing.com/de/s/', '_blank')
          }
        >
          <span data-testid="HELP_CENTER">
            <Styled.Link size="small">
              <FormattedMessage
                id="EP_HELP_CENTER"
                defaultMessage="EP_HELP_CENTER"
              />
            </Styled.Link>
          </span>
        </Styled.ListItem>
      )}
    </>
  );
};

type ListProps = {
  closePopUp: () => void;
  sharePage: () => void;
};

const List: FC<ListProps> = ({ sharePage, closePopUp }) => {
  const { isEditing } = useEditContext();
  const { showError } = useErrorContext();
  const { pageContext } = usePageContext();
  const { isEditor } = pageContext;

  return (
    <>
      <Styled.MoreMenuTitle noMargin size="small">
        <FormattedMessage
          id="EP_CHOOSE_ACTION"
          defaultMessage="EP_CHOOSE_ACTION"
        />
      </Styled.MoreMenuTitle>
      <span data-testid="HEADER_MORE_ACTIONS_LIST">
        <Styled.ListWrapper>
          <>
            <Styled.ListItem onClick={() => sharePage()} role="menuitem">
              <span data-testid="SHARE_PAGE">
                <Styled.Link size="small">
                  <FormattedMessage
                    id="EP_SHARE_PAGE"
                    defaultMessage="EP_SHARE_PAGE"
                  />
                </Styled.Link>
              </span>
            </Styled.ListItem>
            {!isEditor && (
              <Styled.ListItem role="menuitem">
                <span data-testid="REPORT_PAGE">
                  <ReportButton
                    authorUrn={pageContext.globalId}
                    targetUrn={pageContext.globalId}
                    onSuccess={closePopUp}
                    onError={() =>
                      showError({
                        message: 'EP_GENERIC_FEEDBACK_ERROR',
                      })
                    }
                  >
                    <Styled.Link size="small">
                      <FormattedMessage
                        id="EP_REPORT_PAGE"
                        defaultMessage="EP_REPORT_PAGE"
                      />
                    </Styled.Link>
                  </ReportButton>
                </span>
              </Styled.ListItem>
            )}
            {isEditor && isEditing && <RenderEditorOptions />}
          </>
        </Styled.ListWrapper>
      </span>
    </>
  );
};

export default List;
